import { useEffect, useState } from 'react';

const ClientsSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const clients = [
    {
      name: "JO Allround",
      logo: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/75d8a8153e3f1c8a9336c54819aa85a8.png",
      url: "https://jo-allround.de",
      placeholder: ""
    },
    {
      name: "Musikschule & Musikladen",
      logo: "https://storage.readdy-site.link/project_files/1109ecef-050e-4ad6-a17a-e93e467bcab9/c4dda2b4-db4d-48b7-8876-c12c136b27e9_Logo-mit-Rotor-und-Text-1080px-grau.png?v=82f45faf77ecd2ec0e4ae80d3c200ddd",
      url: "#",
      placeholder: ""
    },
    {
      name: "Kunde 4",
      logo: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/930bc8733cb1e43462390beab058847f.png",
      url: "#",
      placeholder: ""
    },

  ];

  // Dupliziere die Logos für nahtloses Scrollen
  const duplicatedClients = [...clients, ...clients, ...clients];

  return (
    <section className="py-24 lg:py-32 bg-zinc-900 relative overflow-hidden">
      {/* Background Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/30 pointer-events-none"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        {/* Header */}
        <div className={`text-center mb-16 transition-all duration-1000 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          <div className="flex items-center justify-center space-x-3 text-white/60 mb-6">
            <div className="w-12 h-px bg-white/30"></div>
            <span className="text-xs uppercase tracking-[0.3em]">Diese Firmen vertrauen uns</span>
            <div className="w-12 h-px bg-white/30"></div>
          </div>
          <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Ihr Partner für
            <br />
            <span className="text-white/50">digitalen Erfolg</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed">
            Professionelles Webdesign und Online Marketing für Ihr Unternehmen
          </p>
        </div>

        {/* Scrolling Logos */}
        <div className="relative overflow-hidden py-8">
          {/* Gradient Fade on sides */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-zinc-900 to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-zinc-900 to-transparent z-10 pointer-events-none"></div>
          
          <div className="flex animate-scroll">
            {duplicatedClients.map((client, index) => (
              <div
                key={`${client.name}-${index}`}
                className="flex-shrink-0 mx-4 md:mx-8"
              >
                <a
                  href={client.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-44 h-24 md:w-56 md:h-32 bg-zinc-800/50 backdrop-blur-sm rounded-lg border border-white/10 flex items-center justify-center p-4 md:p-6 transition-all duration-500 hover:border-white/30 hover:bg-zinc-800/80 hover:scale-105 cursor-pointer"
                >
                  {client.logo ? (
                    <img
                      src={client.logo}
                      alt={client.name}
                      className="max-w-full max-h-full object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
                    />
                  ) : (
                    <span className="text-white/60 text-sm font-medium text-center leading-tight">
                      {client.placeholder}
                    </span>
                  )}
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Decorative Line */}
        <div className="flex items-center justify-center mt-16">
          <div className="w-24 h-px bg-white/20"></div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;